import { css } from '@emotion/react'
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from '@mui/material'

type Props = {
  rows: {
    menu: string
    price: string
    monthly: boolean
  }[]
}

const PriceTable: React.FC<Props> = ({ rows }) => {
  return (
    <TableContainer component='div' css={styles.tableContainer}>
      <Table css={styles.table} aria-label='simple table'>
        <TableHead>
          <TableRow css={styles.headWrapper}>
            <TableCell css={styles.head}>プラン</TableCell>
            <TableCell css={styles.head}>料金</TableCell>
          </TableRow>
        </TableHead>
        <TableBody color='primary'>
          {rows.map(row => (
            <TableRow key={row.menu} css={styles.row} color='primary'>
              <TableCell
                component='th'
                scope='row'
                css={styles.th}
                color='primary'>
                {row.menu}
              </TableCell>
              <TableCell component='td' css={styles.td} color='primary'>
                {row.price}
                {row.monthly ? <span css={styles.monthly}>/月</span> : null}
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  )
}

const styles = {
  tableContainer: css`
    width: 100%;
    @media (max-width: 768px) {
      width: 90vw;
    }
  `,
  table: css`
    * {
      font-family: 'Noto sans JP', sans-serif;
      font-weight: 500;
      text-align: center;
    }
  `,
  headWrapper: css`
    height: 100px;
  `,
  head: css`
    font-size: 1.2rem;
  `,
  row: css`
    height: 100px;
    @media (max-width: 768px) {
    }
  `,
  th: css`
    width: 30%;
    font-weight: 500;
    font-size: 0.9rem;
    @media (max-width: 768px) {
      font-size: 0.7rem;
      width: auto;
    }
  `,
  td: css`
    font-weight: 700;
    text-align: center;
    font-size: 1.8rem;
    @media (max-width: 768px) {
      font-size: 1.2rem;
    }
  `,
  monthly: css`
    margin-left: 1rem;
    font-weight: 500;
    font-size: 1rem;
  `,
}

export default PriceTable
